import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { useTheme } from 'theming';
import useStyles from './styles';
import clsx from 'clsx';
import { Paper } from '../Paper';
import { Typography } from '../Typography';
import { format, getMinutes } from 'date-fns';
import { Icon } from '..';
var weekdays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

var DateDisplayer = function DateDisplayer(_ref) {
  var _clsx;

  var date = _ref.date,
      label = _ref.label,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'success' : _ref$variant,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles,
      _ref$regular = _ref.regular,
      regular = _ref$regular === void 0 ? true : _ref$regular,
      _ref$showWeekday = _ref.showWeekday,
      showWeekday = _ref$showWeekday === void 0 ? false : _ref$showWeekday,
      _ref$showDay = _ref.showDay,
      showDay = _ref$showDay === void 0 ? true : _ref$showDay,
      _ref$hourTextColor = _ref.hourTextColor,
      hourTextColor = _ref$hourTextColor === void 0 ? '#fff' : _ref$hourTextColor,
      _ref$labelTextColor = _ref.labelTextColor,
      labelTextColor = _ref$labelTextColor === void 0 ? '#fff' : _ref$labelTextColor,
      _ref$weekdayColor = _ref.weekdayColor,
      weekdayColor = _ref$weekdayColor === void 0 ? '#fff' : _ref$weekdayColor,
      icon = _ref.icon,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'success' : _ref$iconColor;
  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _clsx));
  date = new Date(date);
  var day = format(date, 'dd/MM/yy');
  var minutes = getMinutes(date);
  var formatedMinutes = minutes < 10 ? "0".concat(minutes) : minutes;
  var hour = format(date, "HH:").replace(':', 'h');
  var timeString = hour + (minutes !== 0 ? formatedMinutes : '');
  var formattedLabel = label ? label.toLowerCase() : '';
  var formattedWeekday = weekdays[date.getDay()].substring(0, 3).toLowerCase();
  return React.createElement(Paper, {
    customClassName: containerStyle,
    variant: variant,
    inlineStyles: inlineStyles,
    regular: regular
  }, showDay && React.createElement(Typography, {
    variant: 'content2',
    weight: "light",
    inheritColor: true,
    inlineStyles: {
      color: weekdayColor
    }
  }, showWeekday ? formattedWeekday : day), React.createElement(Typography, {
    variant: 'header3',
    weight: 'bolder',
    inheritColor: true,
    inlineStyles: {
      color: hourTextColor
    }
  }, timeString), !!label && React.createElement(React.Fragment, null, React.createElement("span", {
    className: classes.grow
  }), icon && React.createElement(Icon, {
    name: icon,
    height: 20,
    width: 20,
    color: iconColor,
    inlineStyles: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 2
    }
  }), React.createElement(Typography, {
    variant: 'content3',
    weight: 'bold',
    inlineStyles: {
      color: labelTextColor,
      textAlign: 'center'
    }
  }, formattedLabel)));
};

export { DateDisplayer };